import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { RecipeObject, NoteObject } from '../../../interfaces/recipe.interface';
import { AuthService } from '../../authentication/services/auth.service';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { tag } from 'rxjs-spy/operators';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  recipeList$: BehaviorSubject<RecipeObject[]> = new BehaviorSubject<RecipeObject[]>(null);

  constructor(private db: AngularFirestore,  private authService: AuthService) {
    combineLatest(this.publicData(), this.tryData())
      .pipe(
        map(([publcRecipes, myRecipes]) => [...publcRecipes, ...myRecipes]),
        map(item => item.sort(this.sortList))
      ).subscribe(data => this.recipeList$.next(data));
   }

   tryData(): Observable<RecipeObject[]> {
    return  this.authService.user.pipe(
       switchMap(uid => {
         if (uid) {
          return this.personalData(uid.uid);
         } else {
          return this.personalData('anonymous');
         }
       })
     )
   }

   personalData(uid: string): Observable<RecipeObject[]> {
     return this.db.collection('recipes', ref => 
     ref.where('deleted', '==', false)
       .where('visible', '==', false)
       .where('author_uid', '==', uid)
       .orderBy('recipeTitle')
     )
     .snapshotChanges().pipe(
       tag('recipeListSwitchMap'),
       map(data => data.map(a => {
         const data = a.payload.doc.data() as RecipeObject;
         const id = a.payload.doc.id;
         return {id, ...data};
       }))
     );
   }

   publicData(): Observable<RecipeObject[]> {
    return this.db.collection('recipes', ref => 
    ref.where('deleted', '==', false)
      .where('visible', '==', true)
      .orderBy('recipeTitle')
    )
    .snapshotChanges().pipe(
      tag('recipeListPublic'),
      map(data => data.map(a => {
        const data = a.payload.doc.data() as RecipeObject;
        const id = a.payload.doc.id;
        return {id, ...data};
      }))
    );
   }


  postNote(docId: string, note: NoteObject) {
    return this.db.collection('recipes').doc(docId).collection('notes').add(note);
  }


  sortList(a: RecipeObject, b: RecipeObject) {
    if (a.recipeTitle > b.recipeTitle) { return 1; }
    if (a.recipeTitle < b.recipeTitle) { return -1;  }
    return 0;
  }


}
